var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card-text', [_vm.title ? _c('div', {
    staticClass: "text-subtitle-1 mb-2"
  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _vm.loading ? _c('v-skeleton-loader', {
    attrs: {
      "type": "image"
    }
  }) : _vm.stages.length ? _c('div', {
    staticClass: "funnel-wrap"
  }, [_c('v-chart', {
    attrs: {
      "options": _vm.option
    }
  })], 1) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }